export default __webpack_public_path__ + "static/media/pdf-icon.c35dfc50.svg";